import { render, staticRenderFns } from "./AdminManageCase.vue?vue&type=template&id=66537a6b"
import script from "./AdminManageCase.vue?vue&type=script&lang=js"
export * from "./AdminManageCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports